import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import { ArsenalUnit } from '@Models';
import Scroll from 'react-scroll';
import { container } from '@Container';
import { TYPES } from '@Types';
import { ArsenalUnitAction } from '@Redux/actions';
import Repeater from '@Utils/Repeater';
import { ArsenalUnitView } from '@Selectors/arsenal/make/view/ArsenalUnitView';
import { ArsenalStepView } from '@Selectors/arsenal/make/view/ArsenalStepView';
import { Col, Row } from 'reactstrap';
import { PaintStep } from '@Models';

interface IArsenalUnitEditProps {
  unit: ArsenalUnitView;
}

const ArsenalUnitEdit: React.FC<ArsenalUnitEditProps> = ({
                                                           unit,
                                                           set,
                                                         }) => {
  useEffect(() => {
    Scroll.scroller.scrollTo('myScrollToElement', {
      duration: 1000,
      delay: 100,
      smooth: true,
      offset: -50 // Scrolls to element + 50 pixels down the page
    });
  }, []);
  const [comment, setComment] = useState(unit.comment ?? '');

  return (
    <div className="m-2 form-horizontal">
      <Scroll.Element name="myScrollToElement" />

      <Row className="justify-content-center">
        <Repeater data={unit.steps} indexPrefix="arsenal-unit-step">
          {
            (step: ArsenalStepView) => (
              <Col xs={6} md={4} lg={3} xl={2}>
                <label className="w-100 text-center">{step.name}</label>
                <div className="d-flex justify-content-between">
                  <span className="fa-stack" style={{ color: step.color }} onClick={(e) => set(unit.id, step.step, step.value -1)}>
                    <i className="fa-regular fa-circle fa-stack-2x"></i>
                    <i className="fa fa-minus fa-stack-1x fa-inverse"></i>
                  </span>
                  <input className="w-50" type="number" min={0} step={1} value={step.value} onChange={(e) => set(unit.id, step.step, parseInt(e.target.value) ?? 0)} />
                  <span className="fa-stack" style={{ color: step.color }} onClick={(e) => set(unit.id, step.step, step.value + 1)}>
                    <i className="fa-regular fa-circle fa-stack-2x"></i>
                    <i className="fa fa-add fa-stack-1x fa-inverse"></i>
                  </span>
                </div>
              </Col>
            )
          }
        </Repeater>
      </Row>

      <div className="form-group">
        <label htmlFor="comment">Comment:</label>
        <textarea className="ms-1 form-control" name="comment" value={comment}
                  onChange={(e) => setComment(e.target.value)} />
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState, owsProps: IArsenalUnitEditProps) => ({
  unit: owsProps.unit
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const armyListUnitAction = container.get<ArsenalUnitAction>(TYPES.Actions.ArsenalUnitAction);
  return {
    toEdit: (unit: ArsenalUnit, comment: string) => {
      unit.comment = comment;
      dispatch(armyListUnitAction.update({ unit: unit }));
    },
    set: (unitId: string, step: PaintStep, value: number) => {
      dispatch(armyListUnitAction.changeStep({ unitId, step, change: value }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArsenalUnitEdit);

type ArsenalUnitEditProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
